export enum ChangeType {
  Yearly = 'yearly',
  Choose = 'choose',
  Upgrade = 'upgrade',
  Downgrade = 'downgrade',
}

export enum PlanPeriod {
  Yearly = 'yearly',
  Monthly = 'monthly',
}
